import { useEffect, useState } from 'react'

import { LockMessage } from '../common/types'
import { getStoredCompanyId } from '../graphql-client/storedState'
import { useSocket } from './useSocket'

export function useSocketLock({
  entityType,
  entityId,
  initialLockedFor,
}: {
  entityType: 'towing_order' | 'towing_record'
  entityId: number
  initialLockedFor?: string | null
}) {
  const [locked, setLocked] = useState<string | null>(initialLockedFor ?? null)
  const companyId = getStoredCompanyId()
  const socket = useSocket()

  useEffect(() => {
    setLocked(initialLockedFor ?? null)
  }, [initialLockedFor, entityType, entityId])
  
  useEffect(() => {
    if (!companyId) return

    const lockedCallback = (message: string) => {
      try {
        const data: LockMessage = message ? JSON.parse(message) : null
        setLocked(data?.userName ?? null)
      } catch {
        setLocked(null)
      }
    }
    const unlockedCallback = () => setLocked(null)

    const lockedEvent = `company-${companyId}.${entityType}-${entityId}.locked`
    const unlockedEvent = `company-${companyId}.${entityType}-${entityId}.unlocked`

    socket.on(lockedEvent, lockedCallback)
    socket.on(unlockedEvent, unlockedCallback)

    return () => {
      socket.removeEventListener(lockedEvent, lockedCallback)
      socket.removeEventListener(unlockedEvent, unlockedCallback)
    }
  }, [companyId, socket, entityType, entityId])

  return locked
}
